import { EventStatistic } from '../../models/statistic';
import { createReducer, on } from '@ngrx/store';
import { cleanUpEventStatistic, getEventStatisticSuccess } from './statistic.actions';

export const StatisticFeatureKey = 'statistic';

export type StatisticState = {
  event: EventStatistic | null,
};

const initialState: StatisticState = {
  event: null,
}

export const statisticReducer = createReducer(
  initialState,
  on(getEventStatisticSuccess, (state, { eventStatistic }) => ({
    ...state,
    event: eventStatistic,
  })),
  on(cleanUpEventStatistic, (state) => ({
    ...state,
    event: null,
  }))
);
